import { useSegmentFilterContext } from './context'
import { SegmentFilterModal } from '@/Atomic/Widgets/SegmentFilterModal'

export const SegmentFilterModalWrapper: React.FC = () => {
  const { isFilterModalOpen, filter, listId, closeFilterModal, saveFilter } =
    useSegmentFilterContext()

  return (
    <SegmentFilterModal
      isOpen={isFilterModalOpen}
      onClose={closeFilterModal}
      onSave={saveFilter}
      initialFilter={filter}
      listId={listId}
    />
  )
}
